<template>
  <div class="vm-template-vue-results">
    <div class="text-center" v-if="data.pagination_html" v-html="data.pagination_html"></div>

    <table class="table table-striped table-bordered table-condensed">
      <thead>
        <tr>
          <th><div class="text-center">OS</div></th>
          <th><div class="text-center">Name</div></th>
          <th class="hidden-tablet"><div class="text-center">CPU</div></th>
          <th class="hidden-tablet"><div class="text-center">Memory</div></th>
          <th class="hidden-note"><div class="text-center">Boot</div></th>
          <th class="hidden-tablet"><div class="text-center">Disk</div></th>
          <th class="hidden-phone"><div class="text-center">Network</div></th>
          <th><div class="text-center">Created by</div></th>
          <th class="vm-template-actions-col"><div class="text-center">GO !</div></th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="row in data.rows || []" :key="`template-${row.id}`" :id="`vm-row-${row.id}`">
          <td><div class="text-center"><img :src="row.os_icon_url" width="20" height="20"></div></td>
          <td>{{ row.name }}</td>
          <td class="hidden-tablet"><div class="text-center">{{ row.vcpu }}</div></td>
          <td class="hidden-tablet"><div class="text-center">{{ row.memory }}</div></td>
          <td class="hidden-note"><div class="text-center">{{ row.boot }}</div></td>
          <td class="hidden-tablet"><div class="text-center">{{ row.disk }}</div></td>
          <td class="hidden-phone"><div class="text-center">{{ row.network }}</div></td>
          <td><div class="text-center">{{ row.owner }}</div></td>
          <td class="vm-template-actions-col" v-html="row.actions_html"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'

const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({ rows: [], pagination_html: '' })
  }
})

const data = ref(props.initialData || { rows: [], pagination_html: '' })

function handleUpdate(event) {
  data.value = event.detail || { rows: [], pagination_html: '' }
}

onMounted(() => {
  document.addEventListener('scc:vm-template-results:update', handleUpdate)
})

onBeforeUnmount(() => {
  document.removeEventListener('scc:vm-template-results:update', handleUpdate)
})
</script>
